import MuiDialog from "@material-ui/core/Dialog";
import { withStyles } from "@material-ui/styles";

// Hoisted to module scope: the legacy page recreated this wrapper on every
// render, which forced the forms to stay uncontrolled. Do not move it into a
// component body.
const StyledDialog = withStyles({
    paperWidthSm: {
        maxWidth: 720,
        minWidth: 300,
        minHeight: 120,
        borderRadius: 12,
    },
})(MuiDialog);

export default StyledDialog;
